import { render } from "./ProductImage.vue?vue&type=template&id=390a404e&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"

import "./ProductImage.vue?vue&type=style&index=0&id=390a404e&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390a404e"]])

export default __exports__